import BaseAuthenticatorSession from "./baseAuthenticatorSession";
let S = com.ts.mobile.sdk;

export default class CustomPasswordAuthenticatorSession extends BaseAuthenticatorSession {
  constructor(title, username, helper) {
    super(title, username, helper);
  }

  promiseAuthInput() {
    let pwdDiv = document.createElement("div");

    return new Promise((resolve, reject) => {
      pwdDiv.innerHTML = "";
      let password = this.clientContext["password"];
      resolve(
        S.InputOrControlResponse.createInputResponse(
          S.PasswordInput.create(password)
        )
      );
      super.presentUI(pwdDiv);
    });
  }

  promiseRegInput() {
    throw new Error("Method not implemented.");
  }
}
